import React from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { zIndex } from '../../../../../play-core/styles/z-index';
import { desktopHeaderHeight } from '../../../components/Header/Header.globals';
import { mobileSearchHeaderHeight } from '../SearchBar/SearchBar.styles';
import { useSearchDispatch } from '../SearchContext';
import { DiscoverTopics } from './DiscoverTopics';
import { SearchHistory } from './SearchHistory';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const QuickSearchOverlay = () => {
  const dispatch = useSearchDispatch();
  return /*#__PURE__*/_jsx(RemoveScroll, {
    children: /*#__PURE__*/_jsxs(Overlay, {
      onClick: e => {
        /*
         * toogle search if clicked on a link.
         * problems with other alternatives:
         * --> what happens if clicked on a link that's already in the url, brings url replacement hell
         * --> inject toogle by props to deep components, makes them not search state dependent
         */
        if (isLinkClick(e.target)) {
          dispatch({
            type: 'toggle'
          });
        }
      },
      children: [/*#__PURE__*/_jsx(SearchHistory, {}), /*#__PURE__*/_jsx(DiscoverTopics, {})]
    })
  });
};
const isLinkClick = element => {
  if (element.tagName.toLowerCase() === 'a') {
    return true;
  }
  if (element.parentElement) {
    return isLinkClick(element.parentElement);
  }
  return false;
};
const Overlay = styled.div.withConfig({
  displayName: "QuickSearchOverlay__Overlay",
  componentId: "sc-137ooo3-0"
})(["position:fixed;top:", "px;right:0;bottom:0;left:0;overflow-x:hidden;overflow-y:auto;", "{top:", "px;}z-index:", ";background-color:", ";"], desktopHeaderHeight, Viewports.for('small'), mobileSearchHeaderHeight, zIndex.header, Colors.GREY_1a1a1a);